import styles from './styles.module.scss';
import Link from 'next/link';

export default function ListContent({ data }) {

    return (
        <div className={styles.listContent} style={{ '--target-color': data?.theme || '#F3D682' }}>
            <div className={`container ${styles.wrap}`}>
                <h1>{data?.title}</h1>
                {data?.subTitle && <div className={styles.subTitle}>
                    {data?.subTitle}
                </div>}

                <div className={styles.lists}>
                    {data?.list?.map((cnt, index) => (
                        <div key={index} className={styles.cnt}>
                            <div className={styles.action}><Link href={`${cnt?.ctaURL ?? '#'}`} className={styles.cta}>{cnt?.ctaText}</Link></div>
                            <Link href={`${cnt?.ctaURL ?? '#'}`}>
                            {cnt.image && <figure>
                                {/*<img src={cnt.image.url} alt={cnt.image.alternativeText} />*/}
                                <div style={{ backgroundImage: `url('${cnt.image.url}')` }} className={styles.img} alt={cnt.image.alternativeText}></div>
                            </figure>}
                            </Link>
                            {cnt.description && <div className={styles.content}>
                                <div dangerouslySetInnerHTML={{ __html: cnt.description, }} />
                            </div>}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

